<script>
import ProductOptionFilter from './ProductOptionFilter'
import isEqual from 'lodash.isequal'

export default {
    name: 'ProductSingleOptionFilter',
    extends: ProductOptionFilter,
    methods: {
        optionDisabled(option) {
            return !!(
                (
                    this.activeFilters.vals?.length
                    || !this.validFilters
                        .find(element => JSON.stringify(element) === JSON.stringify(option))
                )
                && !this.activeFilters
                    ?.vals
                    ?.find(element => isEqual(element, option))
            )
        },
    }
}
</script>
